import { render, staticRenderFns } from "./PeopleArticle.vue?vue&type=template&id=72e7152f&scoped=true&"
import script from "./PeopleArticle.vue?vue&type=script&lang=js&"
export * from "./PeopleArticle.vue?vue&type=script&lang=js&"
import style0 from "./PeopleArticle.vue?vue&type=style&index=0&id=72e7152f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7152f",
  null
  
)

export default component.exports